import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { AuthStore } from './auth.store';

/** Pagine protette: senza sessione si va all'accesso, ricordando la pagina richiesta (FR-015). */
export const authGuard: CanActivateFn = (_route, state) => {
  const store = inject(AuthStore);
  if (store.isAuthenticated()) {
    return true;
  }
  return inject(Router).createUrlTree(['/login'], {
    queryParams: state.url && state.url !== '/' ? { returnUrl: state.url } : {},
  });
};

/** Pagine solo per anonimi (accesso, registrazione): chi è già dentro va alla Dashboard. */
export const anonymousOnlyGuard: CanActivateFn = () => {
  const store = inject(AuthStore);
  return store.isAuthenticated() ? inject(Router).createUrlTree(['/']) : true;
};

/** Per scegliere fra la struttura interna e quella pubblica, per esempio nella pagina 404. */
export const authenticatedMatch: CanMatchFn = () => inject(AuthStore).isAuthenticated();

/** Pagina della sessione limitata (FR-092). */
export const PENDING_DELETION_URL = '/account/pending-deletion';

/**
 * Account in attesa di eliminazione (FR-092): la sessione è limitata e l'unica pagina
 * disponibile è la scelta fra annullare l'eliminazione e uscire.
 */
export const pendingDeletionGuard: CanActivateFn = () => {
  const store = inject(AuthStore);
  return store.user()?.status === 'pending_deletion'
    ? inject(Router).parseUrl(PENDING_DELETION_URL)
    : true;
};

/** La pagina della sessione limitata: solo per un account in attesa di eliminazione. */
export const pendingDeletionOnlyGuard: CanActivateFn = () => {
  const store = inject(AuthStore);
  const router = inject(Router);
  if (!store.isAuthenticated()) {
    return router.parseUrl('/login');
  }
  return store.user()?.status === 'pending_deletion' ? true : router.parseUrl('/');
};
